import { createFileRoute } from '@tanstack/react-router'
import { HomeRouteComponent } from '@/components/home/HomeRouteComponent'

export const Route = createFileRoute('/$location/')({
	head: ({ params: { location } }) => ({
		meta:
			location === 'Fort-Lauderdale'
				? [
						{ title: "Wellview Care | Fort Lauderdale's Trusted STD Testing & Treatment Center" },
						{
							name: 'description',
							content:
								"Welcome to Wellview Care, Fort Lauderdale's trusted STD testing and treatment center. We offer holistic support, HIV prevention, STI/STD testing and treatment, HEP-C treatments, and more. Contact us for quality care in Fort Lauderdale.",
						},
						{
							name: 'keywords',
							content: 'STD Testing, STD Treatment, HIV Prevention, HCV Treatment, HIV Treatment PrEP, PEP, Fort Lauderdale Healthcare',
						},
					]
				: location === 'Riviera-Beach'
					? [
							{
								title: "Wellview Care | Riviera Beach's Trusted STD Testing & Treatment Center",
							},
							{
								name: 'description',
								content:
									"Welcome to Wellview Care, Riviera Beach's trusted STD testing and treatment center. We offer holistic support, HIV prevention, STI/STD testing and treatment, HEP-C treatments, and more. Contact us for quality care in Fort Lauderdale.",
							},
							{
								name: 'keywords',
								content: 'STD Testing, STD Treatment, HIV Prevention, HCV Treatment, HIV Treatment PrEP, PEP, Rivera Beach Healthcare',
							},
						]
					: location === 'Jacksonville'
						? [
								{
									title: "Wellview Care | Jacksonville's Trusted STD Testing & Treatment Center",
								},
								{
									name: 'description',
									content:
										"Welcome to Wellview Care, Jacksonville's trusted STD testing and treatment center. We offer holistic support, HIV prevention, STI/STD testing and treatment, HEP-C treatments, and more. Contact us for quality care in Jacksonville.",
								},
								{
									name: 'keywords',
									content: 'STD Testing, STD Treatment, HIV Prevention, HCV Treatment, HIV Treatment PrEP, PEP, Jacksonville Healthcare',
								},
							]
						: location === 'Fort-Pierce'
							? [
									{
										title: "Wellview Care | Fort Pierce's Trusted STD Testing & Treatment Center",
									},
									{
										name: 'description',
										content:
											"Welcome to Wellview Care, Fort Pierce's trusted STD testing and treatment center. We offer holistic support, HIV prevention, STI/STD testing and treatment, HEP-C treatments, and more. Contact us for quality care in Fort Pierce.",
									},
									{
										name: 'keywords',
										content: 'STD Testing, STD Treatment, HIV Prevention, HCV Treatment, HIV Treatment PrEP, PEP, Fort Pierce Healthcare',
									},
								]
							: [
									{ title: 'A HIV, Hepatitis C (HEP C) Testing and Treatment Clinic in Fort Lauderdale, Fort Pierce, Rivera Beach - Wellview Care' },
									{
										name: 'description',
										content:
											'Wellview Care is a specialized clinic for STD testing and treatment, with a primary focus on HIV, Hepatitis C (HEP C), and preventive services such as PrEP. Call Now!',
									},
									{
										name: 'keywords',
										content: 'Wellview Care, STD testing service, STD clinic, HIV testing center',
									},
								],
	}),
	component: HomeRouteComponent,
})
